import angular from 'angular';

require('./lbaPerDiemFileUploader.scss');
require('../lbaRouteRoot/lbaRouteRoot.scss');

const $inject = ['$q', 'dataService', 'perDiemService', 'Upload', '$timeout', '$rootScope', '$scope','$http'];

const lbaPerDiemFileUploaderCtrl = function ($q, dataService, perDiemService, Upload, $timeout, $rootScope, $scope, $http) {
  let vm = this;

  vm.messages = "";
  vm.hasError = false;
  vm.saving = false;
  vm.open = open;

  vm.dateFormat = 'MM/dd/yyyy';
  var today = new Date();
  vm.placeholder = today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear();

  vm.status = {
    opened: false
  };

  vm.dateOptions = {
    formatYear: 'yy',
    startingDay: 0,
    showWeeks: false
  };

  function open() {
    vm.status.opened = true;
  }

  function getResponseMessage(response) {
    var data = response && response.data;
    var messages = [];

    if (!data) {
      return 'The file upload failed.';
    }

    if (typeof data === 'string') {
      return data;
    }

    if (Array.isArray(data.Messages)) {
      messages = data.Messages.filter(function (message) {
        return message;
      });
    }

    if (Array.isArray(data.Errors)) {
      messages = messages.concat(data.Errors.map(function (error) {
        return error && error.Message ? error.Message : error;
      }));
    }

    if (data.Message && messages.indexOf(data.Message) === -1) {
      messages.push(data.Message);
    }

    if (messages.length) {
      return messages.join("\n");
    }

    return 'The file upload failed.';
  }

  vm.upload = function (file) {
    if (!file) {
      return false;
    }

    vm.saving = true;
    vm.messages = "";

    $rootScope.$broadcast('lbaToast:showToast', { message: `Uploading data...`, messageType: 'waiting' });

    var source = document.getElementById("PerDiemFileUploaderSource").value;
    var expirationDate = document.getElementById("PerDiemFileUploaderExpirationDate").value;

    if (!expirationDate)
    {
      expirationDate = vm.placeholder;
    }

    Upload.upload({
      url: `${endPointUrl}/api/PerDiem/Upload?filename=${file.name}&source=${source}&expirationDate=${expirationDate}`,
      data: {
        file: file
      }
    }).then(function (response) {
      vm.saving = false;

      if (response.data.Success) {
        vm.hasError = false;
        $rootScope.$broadcast('lbaToast:showToast', { message: `File has been uploaded.`, messageType: 'success' });
      }
      else {
        vm.hasError = true;
        $rootScope.$broadcast('lbaToast:showToast', { message: 'There are errors.', messageType: 'error' });
      }

      vm.messages = getResponseMessage(response);
    }, function (response) {
      vm.hasError = true;
      vm.saving = false;

      vm.messages = getResponseMessage(response);
      $rootScope.$broadcast('lbaToast:showToast', { message: vm.messages, messageType: 'error' });
    });
  };
};

lbaPerDiemFileUploaderCtrl.$inject = $inject;

export default lbaPerDiemFileUploaderCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaPerDiemFileUploader/lbaPerDiemFileUploaderCtrl.js